import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AppStateService } from 'src/app/Services/AppState/app-state.service';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss'],
  standalone: true,
  imports: [
    CommonModule
    , NgxSkeletonLoaderModule
  ]
})
export class ProductComponent implements OnChanges{
  @Input() Props?: Props;
  @Input() appearance: 'default' | 'home' = 'default';
  public isLoading = true;

  get description(): string {
    return (this.Props?.description || '')
      .replace(/\b(?:e|y|con|de)\s+(?:inteligencia\s+artificial|IA|AI)\b/gi, '')
      .replace(/\b(?:inteligencia\s+artificial|IA|AI)\b/gi, '')
      .replace(/ {2,}/g, ' ')
      .trim();
  }

  constructor(
    private appStateService: AppStateService
  ) { }

  onSelect(props?: Props){
     
    if(!!props){
      const {code, isPublic, name, isExpired} = props;
      !isExpired && this.appStateService.onSelectProduct(code, isPublic, name);
    }
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes.Props?.currentValue){
      this.isLoading = false;
    }
    
  }

}

interface Props{
  code: string;
  isPublic: boolean;
  name: string;
  imgUrl: string;
  isExpired: boolean;
  description: string;
  isNew: boolean;
}
